export enum FiveMinuteQuestion {
  gratefulFor = "gratefulFor",
  plansToMakeItGreat = "plansToMakeItGreat",
  dailyAffirmation = "dailyAffirmation",
  amazingThingsToday = "amazingThingsToday",
  proudOfMyself = "proudOfMyself",
  couldHaveDone = "couldHaveDone",
}
